import { DateFilterType } from "@/utils/datetime"

export interface IWebhook {
  id?: string
  url: string
  key?: string
}

export enum WebhookLogStatus {
  SUCCEEDED = "succeeded",
  FAILED = "failed",
}

export interface IWebhookLog {
  id?: string
  eventId: string
  webhookId: string
  status: WebhookLogStatus
  description?: string
  createdAt: number
  data: string // JSON string
}

export interface GetWebhookLogsFilters {
  limit?: number
  offset?: number
  dates?: DateFilterType
  order_id?: string
  event_id?: string
}